<template>
  <div>
    <div class="row datePickerControl" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
          class="form-control-label"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <b-input-group v-if="!control.readonly">
          <b-input-group-prepend class="toggle-wrapper" is-text>
            <button class="toggle-calendar" type="button" title="Toggle" data-toggle>
              <icon name="calendar" />
            </button>
          </b-input-group-prepend>
          <flat-pickr
            id="datapicker"
            :config="{
              wrap: true,
              allowInput: false,
              formatDate: formatDate
            }"
            v-model.trim="$v.value.$model"
            :class="{ 'is-invalid': $v.value.$error }"
            class="form-control datepicker"
            :readonly="this.control.readonly"
            :name="control.fieldName"
            @on-change="save"
          />
          <b-input-group-append v-if="control.value">
            <b-button variant="danger" size="sm" @click="remove">
              <icon name="remove" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <span v-else>{{ formatDate(control.value) }}</span>
      </div>
    </div>
    <div v-else>
      <label
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        class="form-control-label"
      >{{control.label}}</label>
      <b-input-group v-if="!control.readonly">
        <b-input-group-prepend class="toggle-wrapper" is-text>
          <button class="toggle-calendar" type="button" title="Toggle" data-toggle>
            <icon name="calendar" />
          </button>
        </b-input-group-prepend>
        <flat-pickr
          :config="{
            wrap: true,
            allowInput: true,
            formatDate: formatDate
          }"
          v-model="control.value"
          v-model.trim="$v.value.$model"
          :class="{ 'is-invalid': $v.value.$error }"
          class="form-control datepicker"
          :readonly="this.control.readonly"
          :name="control.fieldName"
          @on-change="save"
        />
        <b-input-group-append v-if="control.value">
          <b-button variant="danger" size="sm" @click="remove">
            <icon name="remove" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <span v-else>{{ formatDate(control.value) }}</span>
    </div>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'
import { CONTROL_CONSTANTS } from '@/components/DataGrid/FormBuilder/config/constants'
import { Hooks } from '@/components/DataGrid/FormBuilder/gui/components/hook_lists'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// helpers
import utils from '@/helpers/utils'

export default {
  name: 'DatePickerControl',
  props: ['control', 'labelPosition'],
  data() {
    return {
      value: this.control.value,
    }
  },
  watch: {
    value(value) {
      this.control.value = value
    },
    'control.value'() {
      this.value = this.control.value
    },
  },
  computed: {
    isRequired() {
      return this.control.required
    },
  },
  methods: {
    formatDate: utils.formatDate,
    save(date) {
      if (this.value === Date.parse(date)) return
      this.value = Date.parse(date)

      const fbInst = this.$instByClass(this, 'form-builder-root')

      fbInst.setRowDataVal(this.control.propName, this.value)
    },
    remove() {
      this.value = null

      const fbInst = this.$instByClass(this, 'form-builder-root')

      fbInst.setRowDataVal(this.control.propName, this.value)
    },
    onValidateHandler() {
      this.$v.value.$touch()
    },
  },
  created() {
    this.$nextTick(() => {
      const fbInst = this.$instByClass(this, 'form-builder-root')

      fbInst.$on('validate', this.onValidateHandler)
    })
  },
  mounted() {
    Hooks.Control.afterInit.run(this.control)
  },
  beforeDestroy() {
    const fbInst = this.$instByClass(this, 'form-builder-root')

    fbInst.$off('validate', this.onValidateHandler)
  },
  validations: {
    value: {
      required: requiredIf('isRequired'),
    },
  },
}
</script>

<style scoped>
.toggle-calendar {
  padding: 0;
  border: 0;
  margin: 0;
  background: none;
}
.toggle-wrapper {
  height: 40px;
}
</style>
